<template>
  <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
  />
  <br />
  <div
    style="
      display: flex;
      justify-content: space-between;
      background-color: #f0f0f0;
      padding: 10px;
      border-radius: 5px;
    "
  >
    <h4 style="margin: 0">Paso 3: Crea una contraseña segura</h4>
    <h4 style="margin: 0">
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">3</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
    </h4>
  </div>
  <hr />
  <div class="progress">
    <div
      class="progress-bar"
      role="progressbar"
      aria-label="Basic example"
      style="width: 60%"
      aria-valuenow="60"
      aria-valuemin="0"
      aria-valuemax="100"
    ></div>
  </div>
  <br />
  <br />
  <div class="mb-3">
    <div class="row">
      <div class="col-4 watermark-container">
        <!-- <img src="@/assets/images/setPassword.png"> -->
        <br />
        <br />
        <hr />
        <h5>Requisitos para la creación de contraseña</h5>
        <hr />
        <ul>
          <li>
            <strong>Longitud mínima:</strong> Tu contraseña debe tener
            <strong>al menos 8 caracteres</strong>.
          </li>
          <li>
            <strong>Letras mayúsculas y minúsculas:</strong> Incluye una
            combinación de <strong>letras mayúsculas y minúsculas</strong> para
            aumentar la complejidad de tu contraseña.
          </li>
          <li>
            <strong>Números:</strong> Incorpora
            <strong>al menos un número</strong> para mejorar la seguridad de tu
            contraseña.
          </li>
          <li>
            <strong>Caracteres especiales:</strong> Añade
            <strong>al menos un carácter especial</strong> (e.g., ! @ # $ %)
            para maximizar la seguridad contra ataques de fuerza bruta y
            adivinación.
          </li>
        </ul>
        <p>
          El uso de estas combinaciones ayuda a proteger tu cuenta de accesos no
          autorizados y refuerza la seguridad de tus datos personales y médicos.
        </p>
      </div>
      <div class="col-1"></div>
      <div
        class="col-7"
        style="background-color: lightgoldenrodyellow; padding: 20px"
      >
        <form>
          <div class="mb-3">
            <div class="row">
              <div class="col-12" style="font-weight: bold">
                Datos del Prestador de Salud
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-3">
                <label class="form-label" for="ruc">RUC</label>
              </div>
              <div class="col-7">
                <input
                  type="number"
                  id="ruc"
                  class="form-control"
                  placeholder="Ingrese el RUC del prestador de salud"
                  v-model="usuario.documentoEmpresa"
                />
              </div>
              <div class="col-2">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="validarRUC(usuario.documentoEmpresa)"
                >
                  Validar
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-3">
                <label class="form-label" for="nombreEmpresa"
                  >Nombre Empresa</label
                >
              </div>
              <div class="col-9">
                <input
                  type="text"
                  id="nombreEmpresa"
                  class="form-control"
                  v-model="usuario.nombreEmpresa"
                  disabled
                />
              </div>
            </div>
          </div>
          <hr />
          <div class="mb-3">
            <div class="row">
              <div class="col-12" style="font-weight: bold">
                Datos Personales
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-3">
                <label class="form-label" for="nombre">Documento Id.</label>
              </div>
              <div class="col-7">
                <input
                  type="number"
                  id="nombre"
                  class="form-control"
                  placeholder="Ingrese su número de cédula"
                  v-model="usuario.documentoPersona"
                />
              </div>
              <div class="col-2">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="validarCedula(usuario.documentoPersona)"
                >
                  Validar
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-2">
                <label class="form-label" for="nombre">Pri. Apellido</label>
              </div>
              <div class="col-4">
                <input
                  type="email"
                  id="nombre"
                  class="form-control"
                  v-model="usuario.primerApellido"
                  disabled
                />
              </div>
              <div class="col-2">
                <label class="form-label" for="nombre">Seg. Apellido</label>
              </div>
              <div class="col-4">
                <input
                  type="email"
                  id="nombre"
                  class="form-control"
                  v-model="usuario.segundoApellido"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-2">
                <label class="form-label" for="nombre">Pri. Nombre</label>
              </div>
              <div class="col-4">
                <input
                  type="email"
                  id="nombre"
                  class="form-control"
                  v-model="usuario.primerApellido"
                  disabled
                />
              </div>
              <div class="col-2">
                <label class="form-label" for="nombre">Seg. Nombre</label>
              </div>
              <div class="col-4">
                <input
                  type="email"
                  id="nombre"
                  class="form-control"
                  v-model="usuario.segundoApellido"
                  disabled
                />
              </div>
            </div>
          </div>
          <hr />
          <div class="mb-3">
            <div class="row">
              <div class="col-12" style="font-weight: bold">
                Datos del Usuario
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-4">
                <label class="form-label" for="nombre"
                  >Usuario/correo electrónico</label
                >
              </div>
              <div class="col-8">
                <input
                  type="email"
                  id="nombre"
                  class="form-control"
                  v-model="usuario.nombre"
                  disabled
                />
              </div>
            </div>
          </div>
          <!-- Password input -->
          <div class="form-outline mb-3">
            <div class="row">
              <div class="col-4">
                <label class="form-label" for="clave">Contraseña</label>
              </div>
              <div class="col-8">
                <div class="input-group">
                  <input
                    :type="passwordVisible ? 'text' : 'password'"
                    id="clave"
                    class="form-control"
                    placeholder="Ingrese una contraseña"
                    v-model="usuario.clave"
                    @input="checkPasswordStrength"
                  />
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="togglePasswordVisibility"
                  >
                    <span class="material-symbols-outlined">
                      {{ passwordVisible ? "visibility" : "visibility_off" }}
                    </span>
                  </button>
                </div>
                <div
                  v-if="usuario.clave"
                  :class="`strength-meter mt-2 strength-${passwordStrength.level}`"
                >
                  {{ passwordStrength.message }}
                </div>
              </div>
            </div>
          </div>
          <!-- Password input -->
          <div class="form-outline mb-3">
            <div class="row">
              <div class="col-4">
                <label class="form-label" for="clave"
                  >Confirmar Contraseña</label
                >
              </div>
              <div class="col-8">
                <div class="input-group">
                  <input
                    :type="passwordConfirmationVisible ? 'text' : 'password'"
                    id="clave"
                    class="form-control"
                    placeholder="Confirme su contraseña"
                    v-model="usuario.claveConfirmacion"
                  />
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="togglePasswordConfirmationVisibility"
                  >
                    <span class="material-symbols-outlined">
                      {{
                        passwordConfirmationVisible
                          ? "visibility"
                          : "visibility_off"
                      }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div style="text-align: center">
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="guardarUsuario()"
            >
              Registrar
            </button>
          </div>
          <br />
        </form>
      </div>
    </div>
  </div>
  <p class="mensaje">{{ mensaje }}</p>
  <p class="mensaje">{{ mensaje02 }}</p>
</template>
<script>
import api from "@/services/api";

export default {
  data() {
    return {
      usuario: {},
      mensaje: "",
      mensaje02: "",
      passwordVisible: false,
      passwordConfirmationVisible: false,
      passwordStrength: {
        level: "weak", // 'weak', 'medium', 'strong'
        message: "Débil",
      },
    };
  },
  methods: {
    validarRUC(ruc) {
      if (typeof ruc !== "string") {
        ruc = String(ruc);
      }
      ruc = ruc.trim();
      if (!ruc) {
        alert("ERROR: El RUC no puede ser nulo.");
        return false;
      }
      if (ruc.length !== 13) {
        alert("ERROR: El RUC debe tener 13 dígitos.");
        return false;
      }
      this.usuario.nombreEmpresa = "NOMBRE DE LA EMPRESA";
      return true;
    },
    validarCedula(cedula) {
      if (typeof cedula !== "string") {
        cedula = String(cedula);
      }
      cedula = cedula.trim();
      if (!cedula) {
        alert("ERROR: La cédula no puede ser nula.");
        return false;
      }
      if (cedula.length !== 10) {
        alert("ERROR: La cédula debe tener 10 dígitos.");
        return false;
      }
      this.usuario.primerApellido = "PRIMER APELLIDO";
      this.usuario.segundoApellido = "SEGUNDO APELLIDO";
      this.usuario.primerNombre = "PRIMER NOMBRE";
      this.usuario.segundoNombre = "SEGUNDO NOMBRE";
      return true;
    },
    validarClave() {
      const password = this.usuario.clave;
      const errors = [];
      const minLengthRegex = /.{8,}/;
      const lowerCaseRegex = /(?=.*[a-z])/;
      const upperCaseRegex = /(?=.*[A-Z])/;
      const digitRegex = /(?=.*\d)/;
      const specialCharRegex = /(?=.*[.!@#$%&*()_+=|<>?{}\\[\]~-])/;

      if (
        typeof this.usuario.clave === "undefined" ||
        this.usuario.clave === null
      )
        errors.push("no puede ser nula.");
      /*    
      if (this.usuario.clave.length < 8)
        errors.push("La clave debe tener mínimo 8 caracteres.");
 */
      if (!minLengthRegex.test(password))
        errors.push("debe contener al menos 8 caracteres.");
      if (!lowerCaseRegex.test(password))
        errors.push("debe incluir al menos una letra minúscula.");
      if (!upperCaseRegex.test(password))
        errors.push("debe incluir al menos una letra mayúscula.");
      if (!digitRegex.test(password))
        errors.push("debe contener al menos un número.");
      if (!specialCharRegex.test(password))
        errors.push(
          "debe contener al menos un carácter especial (por ejemplo, .! @ # $ % & * () _ + = | <> ? {} \\ [ ] ~ -)."
        );
      if (this.usuario.clave !== this.usuario.claveConfirmacion)
        errors.push("La confirmación no coincide con la clave registrada.");

      if (errors.length > 0) {
        alert("La contraseña " + errors.join(" "));
        return false;
      } else {
        return true;
      }
    },
    async guardarUsuario() {
      if (!this.validarClave()) return;
      if (!this.usuario.nombreEmpresa) {
        alert("Valide los datos del centro médico.");
        return;
      }
      if (!this.usuario.primerApellido) {
        alert("Valide sus datos.");
        return;
      }
      try {
        this.usuario.idPlan = window.sessionStorage.getItem("idPlan");
        const response = await api.post("/registro",
          this.usuario
        );
        // Procesa la respuesta aquí, como redirigir al usuario o mostrar un mensaje de éxito
        console.log("Pago registrado:", response.data);
        window.sessionStorage.setItem("idPago", response.data.idPago);
      } catch (error) {
        // Maneja los errores aquí
        if (error.response && error.response.data) {
          // Si el servidor devuelve un error de respuesta
          console.error("Error de registro:", error.response.data);
          this.errores = error.response.data.errors || [
            "Error desconocido durante el registro.",
          ];
        } else {
          // Errores de red o de solicitud
          console.error("Error al realizar la solicitud:", error.message);
          this.errores = [error.message];
        }
      }
      this.$router.push("Registro04FP");
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    togglePasswordConfirmationVisibility() {
      this.passwordConfirmationVisible = !this.passwordConfirmationVisible;
    },
    checkPasswordStrength() {
      const password = this.usuario.clave;
      const strength = {
        level: "weak",
        score: 0,
        message: "Débil",
      };

      // Incrementar puntuación por cada criterio cumplido
      if (password.length >= 8) strength.score++;
      if (/[a-z]/.test(password) && /[A-Z]/.test(password)) strength.score++;
      if (/[0-9]/.test(password)) strength.score++;
      if (/[^A-Za-z0-9]/.test(password)) strength.score++;

      // Ajustar el mensaje y nivel según la puntuación
      if (strength.score === 1) {
        strength.message = "Débil";
        strength.level = "weak";
      } else if (strength.score === 2) {
        strength.message = "Moderada";
        strength.level = "medium";
      } else if (strength.score > 2) {
        strength.message = "Fuerte";
        strength.level = "strong";
      }

      this.passwordStrength = strength;
    },
  },
  mounted() {
    this.usuario.nombre = window.sessionStorage.getItem("registro_email");
  },
};
</script>
<style src="@/assets/css/registro03Usuario.css" scoped></style>
<style scoped>
.strength-meter {
  padding: 5px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}

.strength-weak {
  background-color: #dc3545; /* red */
}

.strength-medium {
  background-color: #ffc107; /* yellow */
}

.strength-strong {
  background-color: #28a745; /* green */
}
</style>
